export default class LoginRequest {
  geraet: string
  username: string
  password: string
  fcmToken: string
  randomtext: string
}
